import Icon from '@components/Icon'

import styles from './styles.module.scss'

const Legend = () => (
    <div className={styles.legend}>
        <Icon type="park" className="mr-1" size="xxs" />
        <T>map.resultsList.legend.indigo</T>
    </div>
)

export default Legend
